import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: #131a25;\n  padding: 0 16px;\n  border-radius: 10px;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n  font-size: 14px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import styled from "styled-components";
import { space } from "styled-system";
import { WarningIcon, ErrorIcon, CheckmarkCircleFillIcon } from "../Svg";
import { Text } from "../Text";
import { Box } from "../Box";
var MessageContext = /*#__PURE__*/ React.createContext({
    variant: "success"
});
var Icons = {
    warning: WarningIcon,
    danger: ErrorIcon,
    success: CheckmarkCircleFillIcon
};
var MessageContainer = styled.div.withConfig({
    componentId: "sc-eca42e20-0"
})(_templateObject(), space);
var Flex = styled.div.withConfig({
    componentId: "sc-eca42e20-1"
})(_templateObject1());
export var StyledCircle = styled.div.withConfig({
    componentId: "sc-eca42e20-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
});
var colors = {
    // these color names should be place in the theme once the palette is finalized
    warning: "#0358D8",
    success: "#0358D8",
    danger: "#0358D8"
};
export var MessageText = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var ctx = useContext(MessageContext);
    return /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({
        lineHeight: "130%",
        fontSize: "14px" /* color={colors[ctx?.variant]} */ ,
        color: "#9FA9B9"
    }, props), {
        children: children
    }));
};
var Message = function(_param) {
    var children = _param.children, variant = _param.variant, icon = _param.icon, action = _param.action, actionInline = _param.actionInline, props = _object_without_properties(_param, [
        "children",
        "variant",
        "icon",
        "action",
        "actionInline"
    ]);
    var Icon = Icons[variant];
    return /*#__PURE__*/ _jsx(MessageContext.Provider, {
        value: {
            variant: variant
        },
        children: /*#__PURE__*/ _jsxs(MessageContainer, _object_spread_props(_object_spread({
            variant: variant
        }, props), {
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                borderRight: "1px solid #1E2531",
                                alignItems: "center"
                            },
                            mr: "15px",
                            children: /*#__PURE__*/ _jsx(StyledCircle, {
                                children: "i"
                            })
                        }),
                        children,
                        actionInline && action
                    ]
                }),
                !actionInline && action
            ]
        }))
    });
};
export default Message;
